import { CdpEuiccMnoListResponse } from "../app/shared/models/layout/cdp/euicc/mno/list/CdpEuicMnoList";

export function response(): CdpEuiccMnoListResponse {
    return { cmd: { success: true, params: { mnos: [{ "id": "1.3.6.1.4.1.74", "name": "AT\u0026T Wireless" }] } } }
}
